module.exports = __webpack_public_path__ + "static/media/Pug.a8759007.png";